import { ColumnDef } from './column-def';

export type CellData<TItem, TData> = { item: TItem, columnDef: ColumnDef<TItem>, data: TData };
